/**
 * Shared by both Container Shipments screens: the legacy OrdersTabView (warehouse roles) and the
 * staff list page (StaffListPage, PGSS-5655). Both use the same four tab names.
 */

/**
 * PGSS-5670: Container Shipments remembers its tab.
 *
 * Saving a container (ShipmentOrder) navigates back to the bare /shipments/containers, so both
 * screens reopened on their first tab. The chosen tab is kept per browser tab in sessionStorage
 * and used whenever the page arrives without one.
 */
export const CONTAINER_SHIPMENTS_TAB_KEY = 'containerShipments.selectedTab';

function storage() {
  try {
    return typeof window !== 'undefined' ? window.sessionStorage : null;
  } catch (e) {
    return null;
  }
}

/** The remembered tab name, or null. */
export function rememberedContainerTab(store = storage()) {
  try {
    return store?.getItem(CONTAINER_SHIPMENTS_TAB_KEY) || null;
  } catch (e) {
    return null;
  }
}

/** Remember a tab name. */
export function rememberContainerTab(name, store = storage()) {
  if (!name) return;
  try {
    store?.setItem(CONTAINER_SHIPMENTS_TAB_KEY, name);
  } catch (e) {
    // Storage can be unavailable (private mode, quota); the page still opens on its first tab.
  }
}

/** OrdersTabView: index of the remembered tab in `tabs` ({ title }), or 0. */
export function rememberedTabIndex(tabs, store = storage()) {
  const name = rememberedContainerTab(store);
  const index = (tabs || []).findIndex((tab) => tab.title === name);
  return index >= 0 ? index : 0;
}

/** OrdersTabView: remember the tab at `index` of `tabs` ({ title }). */
export function rememberTab(tabs, index, store = storage()) {
  rememberContainerTab(tabs?.[index]?.title, store);
}

/** statuses_types.name of SHIPMENT_COMPLETED, the status Include Archive Container adds to the list. */
export const SHIPMENT_COMPLETED_STATUS = 'Shipment Completed';

/**
 * PGSS-5671: with Include Archive Container on, the Container Shipments list also returns completed
 * containers (ShipmentSpecificationBuilder adds SHIPMENT_COMPLETED), but each tab's status options
 * are a fixed list without it, so those rows could not be filtered. Offer it whenever the list
 * includes them. `search` is the page's query string, where both screens keep `include_archive`.
 */
export function containerStatusOptions(names, listType, search) {
  const list = names || [];
  if (listType !== 'container') return list;
  if (new URLSearchParams(search || '').get('include_archive') !== 'true') return list;
  return list.includes(SHIPMENT_COMPLETED_STATUS) ? list : [...list, SHIPMENT_COMPLETED_STATUS];
}
